export default __webpack_public_path__ + "close-big.cb653089085b79a9.svg";